module.exports = __webpack_public_path__ + "img/logo_strip.a9476faa.png";